import { Box, SelectChangeEvent, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Modal, Radio, TextField, InputAdornment, CircularProgress, Button } from "@mui/material";
// import * as React from "react";
// import { Grid, SelectChangeEvent, Typography, Stack, Box } from "@mui/material";
import { RadioProps } from '@mui/material/Radio';
import  { FC, useState, useEffect, useRef } from "react";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { styled } from '@mui/material/styles';
import StarTwoToneIcon from '@mui/icons-material/StarTwoTone';
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { fetchBankById, fetchBanks } from '../../store/bankStore/bankThunk';
import qrImage from '../../assets/qr-image.png';
import { AdjustStockBySkuId } from "../../store/inventoryStore/inventoryThunk"
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { StockHistoryFormInputs, AdjustStockHistoryPayload } from "../../utils/inventory.types";
import LoadingButton from "@mui/lab/LoadingButton";
import { ApiStatus } from "../../utils/api.types";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '0ms',
    width: 425,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
}));
  
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});
  
// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
    return (
        <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
        />
    );
}

// Schema to validate account form.
const schema = yup.object().shape({
    qty: yup.string().required("Add/Reduce Qty is required"),
});

interface AdjustStockProps {
    selectedData: any;
    visible: boolean;
    setVisible: (val:boolean) => void;
}
  

const AdjustStock: FC<AdjustStockProps> = ({selectedData, visible, setVisible}) => {

    const { status } = useAppSelector(state => state.inventories);
    const { selectedAccount } = useAppSelector(state => state.auth);
    const dispatch = useAppDispatch();

    const [stockType, setStockType] = useState(1);
    const [selectedInventory, setSelectedInventory] = useState<any>();
    const [finalStockValue, setFinalStockValue] = useState(0);

    // use form
    const methods = useForm<StockHistoryFormInputs>({
        resolver: yupResolver(schema),
    });
    const formRef = useRef<any>();

    const onClose = () => {
        console.log("Onclose called ----");
        methods.reset();
        setVisible(false)
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted && selectedData) {
            console.log(selectedData);
            setSelectedInventory(selectedData);
        }
        return () => {
            isMounted = false;
        };
    }, [selectedData]);


    //Method to handle invoice form submit.
  const onSubmit = async (data: StockHistoryFormInputs) => {
    console.log("onSubmit Called ======== ");
    console.log(data);
    if (data) {
        data.qty = Number(data.qty);
        data.account = selectedAccount._id;
        if (stockType == 1) { 
            data.isAdd = true;
            data.isSub = false;
            data.type = 'Add Stock'
        } else {
            data.isAdd = false;
            data.isSub = true;
            data.type = 'Reduce Stock'
        }
    }
    console.log("final form data ===> ", data);

    const finalData: AdjustStockHistoryPayload = {
        skuId: selectedInventory._id,
        stockHistoryPayload: data
    }

    try {
        await dispatch(AdjustStockBySkuId(finalData)).unwrap().then(async (data) => {
            if (data) {
                console.log(data);
                let _skuHistoryId = data.skuHistory._id;
                console.log(_skuHistoryId);
                
                if(_skuHistoryId) {
                    console.log("Inside _sku id");
                    onClose();
                }
                console.log("Outside _sku id");
                // if (_inventoryId) setNewInventoryId(_inventoryId)
            }
        });
    } catch (error: any) {
      // Empty catch block. 
    }
  };


    return(
        <Modal
            open={visible}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    setVisible(true)
                }
            }}
        >
            <FormProvider {...methods}>
            <Box sx={style} component="form" onSubmit={methods.handleSubmit(data => onSubmit(data))} ref={formRef} noValidate>
            <Grid container >
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                    <LoadingButton
                      type="submit"
                      name={'submit'}
                      // disabled={!methods.formState.isValid}
                      loading={status === ApiStatus.LOADING}
                      style={{color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff', marginRight:10 }}
                      variant="contained"
                      size='small'> 
                      {`Save`} 
                    </LoadingButton>

                    <Button
                        style={{color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff', marginRight:10 }}
                        variant="contained"
                        size='small'
                        onClick={onClose} >
                        Cancel
                    </Button>
                </div>
                <h3  style={{marginTop:-2}}>Adjust Stock </h3>
                </Grid>
                
            </Grid>
            
            {!selectedInventory ? <CircularProgress></CircularProgress> :
            <Grid container p={2} spacing={2}>
                <Grid item xs={12} >
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Item Name {JSON.stringify('')}</h5>
                    <h5 style={{fontWeight:'normal',color:'#000',fontSize:15}}>{String(selectedInventory.name).length > 100 ? String(selectedInventory.name).substring(0,100) + '...' : String(selectedInventory.name)}</h5>
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>{selectedInventory.description}</h5>
                </Grid>
                <Grid item xs={8} >
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Add Or Reduce Stock</h5>
                    <div style={{marginLeft:-5}}>
                    <BpRadio  checked={stockType === 1} onChange={()=> {
                        // handleListItemClick(1);
                        setStockType(1);
                    }} size="small" style={{marginRight:-3}}/>
                    <label onClick={()=> {
                        // handleListItemClick(1);
                        setStockType(1);
                    }}>Add Stock</label>
                    <BpRadio checked={stockType === 2} onChange={()=> {
                        // handleListItemClick(2);
                        setStockType(2);
                    }} size="small" style={{marginRight:-3,marginLeft:5}}/>
                    <label onClick={()=> {
                        // handleListItemClick(2);
                        setStockType(2);
                    }}>Reduce Stock</label>
                    </div> 
                </Grid>
            
                <Grid item xs={4} >
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Current Stock</h5>
                    <h5 style={{fontWeight:'normal',color:'#000',fontSize:15,marginBottom:10}}>
                        {(selectedInventory && selectedInventory.stock ) ? 
                            `${selectedInventory.stock.currentStock} 
                            ${(selectedInventory.sale && selectedInventory.sale.unit) ? selectedInventory.sale.unit.code : ''}` : '-'}</h5>
                </Grid>

                <Grid item xs={8} pr={2}>
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Add Or Reduce Stock</h5>
                    <TextField placeholder="Enter Quantity" required size="small"
                        {...methods.register('qty')}
                        type="number"
                        className='c-text-field-4' 
                        variant="standard" 
                        sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                        onChange={(e) => setFinalStockValue(Number(e.target.value))}
                        InputProps={{
                        disableUnderline: true,
                        endAdornment:<InputAdornment position="start" style={{marginTop:-5}}>{`${(selectedInventory.sale && selectedInventory.sale.unit) ? selectedInventory.sale.unit.code : ''}`}</InputAdornment>
                        }}
                    />
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.qty?.message ?? ""}</p>
                </Grid>

                <Grid item xs={4} >
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Final Stock</h5>
                    <h5 style={{fontWeight:'normal',color:'#000',fontSize:15,marginBottom:10}}>
                        {stockType == 1 ? finalStockValue + Number(selectedInventory.stock.currentStock) : Number(selectedInventory.stock.currentStock) - finalStockValue} {`${(selectedInventory.sale && selectedInventory.sale.unit) ? selectedInventory.sale.unit.code : ''}`}</h5>
                </Grid>

                <Grid item xs={12} >
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Remarks (Optional)</h5>
                    <TextField 
                        className='c-text-field-4' 
                        variant="standard" 
                        size="small"
                        {...methods.register('remarks')}
                        multiline
                        rows={4}
                        sx={{width:'100%',mt:0.5,borderRadius:'8px!important',height:100}} 
                        placeholder='Reason for adjusting the stock ...'
                        InputProps={{
                            disableUnderline: true
                        }} 
                    />
                </Grid>
            </Grid>
            }
            </Box>
            </FormProvider>
        </Modal>
    )
};
export default AdjustStock;